// extracted by mini-css-extract-plugin
module.exports = {"current-condition__wrapper":"current-condition__wrapper","current-condition__link":"current-condition__link","current-condition__heading":"current-condition__heading"};